import { listen } from "@tauri-apps/api/event";
import { useAtom } from "jotai";
import { useEffect } from "react";

import { $tauriEvents, type TauriEvent } from "../../internal/tauri-events";

export const useTauriEventListener = (eventType: string, callback: (event: TauriEvent) => void) => {
	const [tauriEvents, acknowledge] = useAtom($tauriEvents);

	useEffect(() => {
		if (!listen) {
			return;
		}

		listen("tauri-listener:pending-events-added", () => {
			// When a new event is added to the database, running acknowledge without
			// any parameters will fetch it from the database
			acknowledge();
		});
	}, [listen]);

	useEffect(() => {
		// Handle the first event in the list that we're listening for and acknowledge it,
		// which will cause this list to be re-rendered
		const tauriEvent = tauriEvents.find((event) => event.event.type === eventType);
		if (tauriEvent) {
			acknowledge(tauriEvent.id);

			callback(tauriEvent.event);
		}
	}, [tauriEvents, eventType, callback]);
};
